var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.venues?.loading),expression:"venues?.loading"}],staticClass:"venues-list"},[_c('venues-map-view',{attrs:{"selected":_vm.recommendations,"venues":_vm.venues,"addToListLabel":"Add To Queue","shouldSelectSpaces":true},on:{"select":_vm.addToQueue,"remove":_vm.removeFromQueue}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }